import React from 'react';
import PropTypes from 'prop-types';

import { st, classes } from './Accordion.st.css';
import AccordionItem from './AccordionItem';
import { skins, openButtonIconType } from './constants';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import triggerEvent from '../../../../../../services/bi/biSiteLogger';
import biData from '../../../../../../services/bi/biEvents.json';

class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openIndexes: this._findOpenIndexes(this.props.items, true),
      itemList: props.items,
    };
  }

  static displayName = 'Accordion';

  static propTypes = {
    /** Applied as data-hook HTML attribute that can be used to create driver in testing */
    dataHook: PropTypes.string,

    /** allow multiple rows to be opened simultaneously */
    multiple: PropTypes.bool,

    /** Accordion skin color */
    skin: PropTypes.oneOf([skins.loose, skins.tight]),

    settings: PropTypes.object,

    /** open/close icon (arrow or plus) **/
    openButtonIcon: PropTypes.oneOf([
      openButtonIconType.arrow,
      openButtonIconType.plus,
    ]),
    // divider:PropTypes.object({width:PropTypes.number, color:PropTypes.string}),
    /** accordion items nodes */
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.node,
        children: PropTypes.node,
        expandLabel: PropTypes.node,
        collapseLabel: PropTypes.node,
        onToggle: PropTypes.func,
        onMouseEnter: PropTypes.func,
        onMouseleave: PropTypes.func,
        isOpen: PropTypes.bool,
        design: PropTypes.object,
        styleParams: PropTypes.object,
      }),
    ),
  };

  static defaultProps = {
    items: [],
    multiple: false,
    skin: skins.loose,
    openButtonIcon: openButtonIconType.arrow,
  };

  _findOpenIndexes = (items) =>
    items
      .map((item, index) => (item.isOpen ? index : null))
      .filter((index) => index !== null);

  _compareOpenItems = (currentItems, prevItems) => {
    if (prevItems.length !== currentItems.length) {
      return false;
    }
    for (let i = 0; i < prevItems.length; i++) {
      if (prevItems[i].isOpen !== currentItems[i].isOpen) {
        return false;
      }
    }
    return true;
  };

  componentDidUpdate = (prevProps) => {
    if (!this._compareOpenItems(this.props.items, prevProps.items)) {
      this.setState({
        openIndexes: this._findOpenIndexes(this.props.items),
      });
    }
  };

  _toggle = (index, item) => () => {
    this.setState(
      ({ openIndexes }) => ({
        openIndexes: openIndexes.includes(index)
          ? openIndexes.filter((i) => i !== index)
          : this.props.multiple
          ? [...openIndexes, index]
          : [index],
      }),
      () => {
        if (this.state.openIndexes.length) {
          // const description = this.props.faqList.categories.find(
          //   (x) => x.id === item.categoryId,
          // ).title;
          biData.UOU_EXPENDS_A_QUESTION = {
            ...biData.UOU_EXPENDS_A_QUESTION,
            type: this.props.settings.layout,
            question_id: item.questionId,
            category_id: item.categoryId,
            question_order: item.question_order,
          };
          triggerEvent(biData.UOU_EXPENDS_A_QUESTION);
        }
      },
    );
  };

  render() {
    const { openIndexes } = this.state;
    const {
      dataHook,
      items,
      skin,
      openButtonIcon,
      design,
      styleParams,
      settings,
    } = this.props;
    return (
      <>
        <ul
          className={st(classes.accordionItems)}
          data-hook={dataHook}
          style={{ direction: settings.direction }}
        >
          {items
            .sort((a, b) => a.question_order - b.question_order) // sort questions according order
            .map((item, index, allItems) => (
              <li>
                <AccordionItem
                  className={st(classes.item, {
                    first: index === 0,
                    last: index === allItems.length - 1,
                  })}
                  isFirst={index === 0}
                  isLast={index === allItems.length - 1}
                  itemIndex={'item' + index}
                  key={index}
                  {...item}
                  onToggle={this._toggle(index, item)}
                  isOpen={openIndexes.includes(index)}
                  skin={skin}
                  openButtonIcon={openButtonIcon}
                  design={design}
                  styleParams={styleParams}
                />
              </li>
            ))}
        </ul>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Accordion));
